import { ChildrenModelBase } from './children-base.model';

export class ComparerOperator extends ChildrenModelBase {
  name: string;
  symbol: string;
}
